import React from 'react';
import { Modal, Collapse } from 'antd-mobile';
import { motion } from 'framer-motion';
import { useI18n } from '@/hooks/useI18n';

interface ScoringCriteria {
  name: string;
  value: string;
}

interface DimensionModalProps {
  visible: boolean;
  onClose: () => void;
  dimensions: ScoringCriteria[];
}

const DimensionModal: React.FC<DimensionModalProps> = ({ visible, onClose, dimensions }) => {
  const { t } = useI18n();
  
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      content={
        <div className="p-2">
          <div className="text-center mb-3">
            <h3 className="text-lg font-medium text-gray-900">
              {t('ai.analysis.dimensionDescription')}
            </h3>
          </div>
          
          <Collapse>
            {dimensions.map((item, index) => (
              <Collapse.Panel key={index.toString()} title={item.name}>
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {item.value}
                  </p>
                </motion.div>
              </Collapse.Panel>
            ))}
          </Collapse>
        </div>
      }
      closeOnAction
      closeOnMaskClick
    />
  );
};

export default DimensionModal;